import { useAppStateStore } from '@/features/application'
import { TypesContextesAutorisesEnum } from '@/features/auth/context-app'
import { MachineEtat } from '@/features/domaine/machine-etats/MachineEtats'
import api from '@/features/services/demande/DemandeAllService'
import {
  CloneDemandeTTConfiguration,
  CreationDemandeTTConfigurations,
  type CloneDemandeLaunch,
} from './CreationDemandeTTConfigurations.ts'

export function useAjouteDemandeTT() {
  const appState = useAppStateStore()

  async function showAjoute() {
    if (!appState.autoriseEcriture('FPE')) throw 'Création outil FPE non autorisée'

    const engine = new MachineEtat(CreationDemandeTTConfigurations)
    const payload = await engine.launch({
      titre: 'Nouvelle demande',
      contextCourant: TypesContextesAutorisesEnum.Adherent,
    })

    return await api.addDemande(payload)
  }

  async function showClone(options: CloneDemandeLaunch) {
    if (!appState.autoriseEcriture('FPE')) throw 'Création outil FPE non autorisée'

    const engine = new MachineEtat(CloneDemandeTTConfiguration)
    const payload = await engine.launch({
      titre: 'Dupliquer une demande',
      contextCourant: TypesContextesAutorisesEnum.Adherent,
      launchParams: options,
    })

    return await api.addDemande(payload)
  }

  return {
    showAjoute,
    showClone,
  }
}
